/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React, { useContext } from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import './styles.scss'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import { CandidatsCards } from 'components/candidats-cards'
import { Cover } from 'components/cover'
import { InfoLayer } from 'components/infoLayer'
import { candidatsData } from '../candidats.yml'

const ARTICLE_ID = '611498512132'

export function AppComponent() {
  return (
    <div className='index'>
      <Masthead inverted articleId={ARTICLE_ID} />
      <ThemeSwitch />

      <Cover />

      <header className='ui vertical  very fitted  segment'>
        <div className='ui container'>
          <div className='ui header'>
            <div className='top-line'>«C’est ou bien ou bien»</div>
            <h1>Notre boîte à questions pour la course au Conseil d’État</h1>
            <h2>
              Treize politiciens et politiciennes en lice pour le Conseil d’État
              le 20 mars se sont soumis à la boîte à questions de «24 heures»
            </h2>
          </div>
        </div>
      </header>

      <div className='ui vertical segment'>
        <div className='ui text container'>
          <div className='ta metainfo'>
            <div className='ta author'>
              Georges Cabrera, Romain Michaud et Mathieu Rudaz
            </div>
            <div className='ta updated'>Mis à jour le 14 février 2022</div>
          </div>
          <div className='ta text'>
            <p>
              «C’est ou bien ou bien», comme on dit par ici. Treize candidates
              et candidats au Conseil d’État se sont soumis à la boîte à
              questions de «24 heures». Et pas toujours facile de choisir entre
              deux propositions. Bien sûr, entre «abattre le loup» et «protéger
              le loup», ou entre «baisse d’impôt» et «statu quo», les clivages
              politiques traditionnels se font jour.
            </p>
            <p>
              Mais dans nos capsules vidéo, on apprendra une crâlée d’autres
              choses sur les personnalités en lice pour le premier tour des
              élections ce 20 mars. Par exemple qu’en bonne Broyarde, Christelle
              Luisier est secrètement fan du HC Fribourg-Gottéron. Ou qu’une
              autre candidate n’a pas le permis de conduire ou que l’un des
              candidats est capable de racler 3, voir 4 fromages à la fois:
              «Vous êtes 25, je suis tout seul, j’assure.»
            </p>
            <p>
              Saurez-vous retrouver le fou de raclette ou la fleur de béton?
            </p>
          </div>
        </div>
      </div>

      <div className='ui vertical segment'>
        <div className='ui container'>
          <CandidatsCards />
        </div>
      </div>

      <InfoLayer candidates={candidatsData} />

      <Footer
        mailTo='interactif@tamedia.ch'
        locale='fr'
        hidePortfolioTeaser
        articleId={ARTICLE_ID}
        credits={[
          ['Vidéos', 'Georges Cabrera et Romain Michaud'],
          ['Conception et réalisation', 'Mathieu Rudaz']
        ]}
      />
    </div>
  )
}
